import React, { useContext, useState } from 'react';
import { ParentContext } from '../cnr/contexts/ParentContext';
import ImageMapping from '../components/swipe/ImageMapping';
import { appIconTypes } from '../enums/appIconTypes';
import { gEnums } from '../enums/globalEnums';
import { iconColorTypes } from '../enums/settingsIconTypes';
import GenericIcon from '../genericControls/GenericIcon';

const UiHeader = (props) => {

  const { caption, icons, storageType, isSingle } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext)
  const { fns } = parentContext ?? {}
  const { navigation_fns } = fns ?? {}

  const [showMapping, setShowMapping] = useState()

  const handlePush = () => navigation_fns.handleNav_item({ key: null }, null, 'add')
  const handleMapping = () => setShowMapping(!showMapping)

  const gi = (key, iconName, onClick, clickOptions, opts, corner) => <GenericIcon giProps={{ key, iconName, onClick, clickOptions, opts, corner }} />

  /** Returns the buttons for the right side of the header */
  const rightButtons = () => {
    const bts = []
    if (icons) {
      icons.forEach((singleIcon, index) => {
        const { handleOnClick, icon, title, showAdd, inverted, fl } = singleIcon ?? {}
        const defaultIcon = showAdd ? appIconTypes.delete : appIconTypes.add
        const bi = icon ? icon : defaultIcon
        const bt = title ? title : 'Add New Items'
        const bc = icon === 'delete' ? iconColorTypes.kill : iconColorTypes.menuItem

        // add button
        handleOnClick && bts.push(gi('ib-click-' + index, bi, handleOnClick ? handleOnClick : handlePush, null, { title: bt, inverted, color: bc, fl: fl }))
        // map button
        storageType === gEnums.storageTypes.floormap && isSingle && bts.push(gi('ib-floormap', 'map outline', handleMapping, null, { title: bt, inverted, color: bc }))
      })
    }
    return bts
  }

  if (showMapping) {
    return <ImageMapping imageMapType={gEnums.imageMapTypes.itemLocation} handleCancel={setShowMapping} />
  } else {
    return <div>
      {caption && caption}
      {rightButtons()}
    </div>
  }
}

export default UiHeader